export default __webpack_public_path__ + "static/media/hht1_ep10_minisitcom_03.24ec334f.png";